import { defineMessages } from 'react-intl';

const scope = 'app.workspace.projects.UnAvailableContent';

export default defineMessages({
  contentNotFoundTitle: {
    id: `${scope}.contentNotFoundTitle`,
    defaultMessage: `This content doesn't exist`,
  },
  contentNotFoundDescription: {
    id: `${scope}.contentNotFoundDescription`,
    defaultMessage: 'It may have been deleted by another user.',
  },
});
